<template>
    <div>
        <b-card class="sa-card sa-card-border mb-3" header="Denominazione (DEN)" header-tag="header">

            <b-card class="sa-card sa-card-border mb-3" header="Parte prima: Oggetti" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Letto</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiLetto" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiLettoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. Libro</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiLibro" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiLibroPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Valigia</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiValigia" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiValigiaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Scopa</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiScopa" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiScopaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Cintura</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiCintura" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiCinturaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Pipa</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiPipa" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiPipaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Martello</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiMartello" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiMartelloPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Candela</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiCandela" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiCandelaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Bilancia</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiBilancia" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiBilanciaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Trattore</label>
                                <b-form-input v-model="jsonDataDenominazione.oggettiTrattore" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.oggettiTrattorePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte I</label>
                        <b-form-input :value="jsonDataDenominazione.oggettiPartePrimaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte seconda: Colori" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Rosso</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriRosso" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriRossoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. Bianco</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriBianco" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriBiancoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Verde</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriVerde" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriVerdePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Nero</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriNero" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriNeroPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Giallo</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriGiallo" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriGialloPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Blu/Azzurro</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriBluAzzurro" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriBluAzzurroPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Marrone</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriMarrone" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriMarronePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Grigio</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriGrigio" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriGrigioPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Viola</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriViola" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriViolaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Arancione</label>
                                <b-form-input v-model="jsonDataDenominazione.coloriArancione" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.coloriArancionePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte II</label>
                        <b-form-input :value="jsonDataDenominazione.coloriParteSecondaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte terza: Nomi composti" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. Aspirapolvere</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiAspirapolvere" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiAspirapolverePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. Lavapiatti/lavastoviglie</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiLavapiattiLavastoviglie" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiLavapiattiLavastovigliePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Grattacielo</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiGrattacielo" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiGrattacieloPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. Cavatappi/cavaturaccioli</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiCavatappiCavaturaccioli" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiCavatappiCavaturaccioliPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Giradischi/grammofono</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiGiradischiGrammofono" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiGiradischiGrammofonoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Apriscatola</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiApriscatola" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiApriscatolaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Battipanni/battitappeti</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiBattipanniBattitappeti" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiBattipanniBattitappetiPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Cacciavite</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiCacciavite" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiCacciavitePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. Mappamondo</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiMappamondo" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiMappamondoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. Schiaccianoci</label>
                                <b-form-input v-model="jsonDataDenominazione.nomiCompostiSchiaccianoci" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.nomiCompostiSchiaccianociPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte III</label>
                        <b-form-input :value="jsonDataDenominazione.nomiCompostiParteTerzaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-card class="sa-card sa-card-border mb-3" header="Parte quarta: Descrizione di figure (esempio: La donna pela le patate)" header-tag="header">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">1. L’uomo mendica</label>
                                <b-form-input v-model="jsonDataDenominazione.figureUomoMendica" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figureUomoMendicaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">2. La donna cola la pasta</label>
                                <b-form-input v-model="jsonDataDenominazione.figureDonnaColaPasta" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figureDonnaColaPastaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">3. Il ragazzo gioca con il cane</label>
                                <b-form-input v-model="jsonDataDenominazione.figureRagazzoGiocaCane" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figureRagazzoGiocaCanePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">4. L’uomo ha pescato uno stivale</label>
                                <b-form-input v-model="jsonDataDenominazione.figureUomoPescaStivale" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figureUomoPescaStivalePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">5. Il ragazzo ha rotto una tazza</label>
                                <b-form-input v-model="jsonDataDenominazione.figureRagazzoRompeTazza" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figureRagazzoRompeTazzaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">6. Padre e figlio giocano a pallone</label>
                                <b-form-input v-model="jsonDataDenominazione.figurePadreFiglioGiocanoPallone" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figurePadreFiglioGiocanoPallonePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">7. Il poliziotto arresta un ladro</label>
                                <b-form-input v-model="jsonDataDenominazione.figurePoliziottoArrestaLadro" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figurePoliziottoArrestaLadroPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">8. Due uomini si salutano</label>
                                <b-form-input v-model="jsonDataDenominazione.figureDueUominiSiSalutano" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figureDueUominiSiSalutanoPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">9. La maestra interroga la bambina alla lavagna</label>
                                <b-form-input v-model="jsonDataDenominazione.figureMaestraInterrogaBambina" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figureMaestraInterrogaBambinaPunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <b-row>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                                <label class="sa-label-data">10. L’uomo è sdraiato sul divano, fuma la pipa e legge il giornale</label>
                                <b-form-input v-model="jsonDataDenominazione.figureUomoDivanoGiornale" :readonly="isReadOnly"></b-form-input>
                            </b-col>
                            <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <label class="sa-label-data">Punteggio</label>
                                <b-form-select v-model.number="jsonDataDenominazione.figureUomoDivanoGiornalePunteggio" :options="punteggioOptions" :disabled="isReadOnly"></b-form-select>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="justify-content-end">
                    <b-col class="aat-field" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">Totale parte IV</label>
                        <b-form-input :value="jsonDataDenominazione.figureParteQuartaPunteggio" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                    </b-col>
                </b-row>
            </b-card>
            <b-row>
                <b-col class="aat-field" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Punteggio totale (parti I–IV)</label>
                    <b-form-input :value="jsonDataDenominazione.denominazionePunteggioTotale" type="number" readonly tabindex="-1" class="font-weight-bold"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "RsaSchedaAachenerAphasieTestDenominazioneEditComponent",
    props: {
        jsonDataDenominazione: { type: Object, required: true },
        isReadOnly: { type: Boolean, default: false },
    },
    data() {
        return {
            punteggioOptions: [
                { value: null, text: "- Seleziona valore -", disabled: true },
                0, 1, 2, 3,
            ],
        };
    },
};
</script>

<style scoped>
.aat-field {
    margin-bottom: 1rem;
}
.aat-field .sa-label-data {
    align-items: flex-end;
    display: flex;
    min-height: 2.5rem;
}
</style>
